import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList }) {

	const [messageTypeList, setMessageTypeList] = useState([])
	const [category, setCategoryList] = useState([])

	useEffect(() => {
		loadMessageTypeList()
		loadCategoryList()
	}, [])


	const loadMessageTypeList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/message-type/list`;
		const response = await fetchWrapper.get(url)
		const customerList = response.data;
		const db = { data: customerList };
		setMessageTypeList(db);
	}

	const loadCategoryList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/category/list`;
		const data = await fetchWrapper.get(url)

		setCategoryList(data)
	}
	const [formData, setFormData] = useState({
		name: '',
		message_type_id: '',
		category_id: '',
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
		message_type_id: Yup.string().required('Required'),
		category_id: Yup.string().required('Required'),
	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = { name: values?.name?.trim(), category_id: values?.category_id, message_type_id: values?.message_type_id }


		const url = `${process.env.REACT_APP_API_URL}/message-template-type/create`;
		await fetchWrapper.post(url, data)
		loadList()
		meClose();
		toast(`Record has been saved `, {
			type: "info"
		});
	}


	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			<Box mb="10px">
				<InputText name="name" title="Name" placeholder="Name" inputProps={{ isRequired: true }} />
			</Box>
			<Box mb="10px">
				<SelectField name="message_type_id" title="Message Type" list={messageTypeList} isRequired />
			</Box>
			<Box mb="10px">
				<SelectField name="category_id" title="Category" list={category} isRequired />
			</Box>
			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Add New Message Type
			</Button>
		</Form>


	)
}

export default Create;